module.exports = __webpack_public_path__ + "img/y-100.ab880648.png";